import { render, staticRenderFns } from "./ModifyRecord.vue?vue&type=template&id=da10f1a8&scoped=true&"
import script from "./ModifyRecord.vue?vue&type=script&lang=js&"
export * from "./ModifyRecord.vue?vue&type=script&lang=js&"
import style0 from "./ModifyRecord.vue?vue&type=style&index=0&id=da10f1a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da10f1a8",
  null
  
)

export default component.exports